export default __webpack_public_path__ + "static/media/wax_login.6c78daac.png";